import React from 'react';
import { List, Datagrid, Filter, BooleanField, TextField, TextInput } from 'react-admin';

const RoleSubMenuFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const RoleSubMenuList = props => (
  <List filters={<RoleSubMenuFilter />} {...props} >
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <BooleanField source="enabled" />
    </Datagrid>
</List>
);

export default RoleSubMenuList